export default async () => {
  return await Promise.resolve({
    loading: 'Lädt...',
    prev: 'Zurück',
    next: 'Weiter',
    hours: 'Stunde | Stunde | Stunden',
    minutes: 'Minute | Minute | Minutes',
    seconds: 'Sekunde | Sekunde | Sekunden',
    the: '',
    and: 'und',
    copyright: '{year} © Asphalte. Alle Rechte vorbehalten.',
    b_corp_certified: 'B Corp zertifiziert',
    color: 'Farbe:',
    hovered_color: 'Überflogene Farbe:',
    preco_of_the_week: 'Nur diese Woche vorbestellbar.',
    next_thuesday: 'Wir sehen uns am Dienstag, 10 Uhr.',
    lauch_day: 'Wir sehen uns am  {day}, 10 Uhr.',
    seo: {
      defaultTitle: 'Asphalte - Einfach. Gute. Klamotten.',
      defaultDesc:
        'Wir sind eine Marke für Personen, die Kleidung mit Stil und Qualität wollen, ohne dabei jeden Monat das Budget zu sprengen.',
    },
    context: {
      h: 'HerrenKollektion',
      f: 'DamenKollektion',
    },
    action: {
      see: 'Produkt ansehen',
      add: 'Hinzufügen',
      added: 'Hinzugefügt',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      buy: 'Kaufen',
      copy: 'Kopieren',
      share: 'Aktie',
      preorder: 'Vorbestellen',
      'add-to-cart': 'In den Einkaufswagen',
      subscribe: 'Mitteilung einrichten',
      unsubscribe: 'Mitteilungen abbestellen',
      checkout: 'Sicher auschecken',
      reduce: 'Weniger anzeigen',
      open: 'Öffnen',
      open_filters: 'Filter öffnen',
      filter: 'Produkte filtern',
      'continue-shopping': 'Weiter einkaufen',
      show_eshop: 'Zeigt Mal die Vorbestellungen',
      close: 'schließen',
      cancel: 'Abbrechen',
      cancel_product: 'Produkt stornieren',
      seePassword: 'See password',
      hidePassword: 'Hide password',
      newsletterSubscribe: 'Ich bin dabei',
      readMore: 'Mehr sehen',
      showAllPictures: 'Alle Fotos anzeigen',
      subscribe_to_list: 'Abonnieren',
      follow_order: 'Bestellung verfolgen',
      logout: 'Ausloggen',
      return: 'Zurück',
      add_address: 'Adresse hinzufügen',
      edit_address: 'Adresse bearbeiten',
      set_as_default: 'Standardadresse',
      save: 'Speichern',
      update_password: 'Passwort aktualisieren',
      show_care_guide: 'Pflegeanleitung anzeigen',
      prev: 'Vorherige',
      next: 'Weiter',
    },
    link: {
      menu: 'Menu',
      infos: 'Infos',
      cart: 'Warenkorb ansehen',
      'sign-in': 'Einloggen',
      news: 'Neuigkeiten',
      account: 'Mein Konto',
    },
    alert: {
      title: 'Meine Mitteilungen',
      desc: `
        <p>Du wartest sehnsüchtig auf Neuigkeiten zu deinen liebsten Asphalte-Teilen? Dann bist du hier genau richtig. Hier findest du alle Produkte, für deren Mitteilungen du dich angemeldet hast. Sobald es etwas zu berichten gibt, erfährst du es als erstes.</p>
        <p>Wenn du hier nichts siehst, dann liegt es vielleicht daran, dass dir noch nichts ins Auge gefallen ist… Keine Sorge, das kann schon mal passieren, wir nehmen es nicht persönlich.</p>
        <p>Wenn du die Liste erweitern möchtest, kannst du natürlich jederzeit einen Blick auf unsere kommenden Vorbestellungen werfen.
        `,
      action: 'Was ist das da am Horizont?',
      none: 'Momentan keine Mitteilungen.',
      tooltip: {
        create: 'Mitteilung einrichten',
        remove: 'Mitteilung deaktivieren',
        love: 'Mitteilung einrichten',
        unlove: 'Mitteilung deaktivieren',
      },
    },
    article: {
      publicated_at: 'Veröffentlicht am {date}.',
      next: 'Nächster Artikel',
    },
    stock: {
      title: 'Lagerverkauf',
      punchline: 'Tolle Teile in wenigen Tagen bei euch.',
      teasing_action: 'Zeigt Mal der Lagerverkauf',

      alert: {
        1: 'Wer zuerst kommt, mahlt zuerst.',
        2: 'Melde dich an und sichere dir einen Vorsprung von 1 Stunde bei der Lagerverkauf.',
        highlight_title: 'Der Lagerverkauf beginnt am {date}',
        receive_alert:
          'Bekomme eine Mitteilung, sobald der Lagerverkauf werden kann:',
        activated:
          'Du bekommst eine Nachricht an diese E-Mail-Adresse <strong>{email}</strong>, sobald wir sagen: Der Lagerverkauf hat begonnen!.',
        deactivated: 'Mitteilungen für der Lagerverkauf abgemeldet',
      },
    },
    card: {
      product: {
        agenda: {
          status: 'Up soon',
          alert: {
            1: 'Wer zuerst kommt, mahlt zuerst.',
            2: 'Melde dich an und sichere dir einen Vorsprung von 1 Stunde bei der Vorbestellung.',
          },
        },
        precommande: {
          status: 'Als Vorbestellung',
        },
        stock: {
          status: 'Auf Lager',
        },
        'number-of-colors': '{number} Farben erhältlich',
        'number-of-colors-soon': '{number} Farben erhältlich',
        'number-of-colors-small': '{number} Farben',
        'nb-preco':
          'Schon <strong>{number}</strong> Vorbestellung | Schon <strong>{number}</strong> Vorbestellung | Schon <strong>{number}</strong> Vorbestellungen',
      },
    },
    cart: {
      title: 'Mein Warenkorb',
      empty: 'Dein Warenkorb ist leer.',
      'sub-total': 'Gesamtsumme',
      'shipping-calculated-later':
        'Versand und Steuern werden beim Checkout berechnet',
      'terms-agree': 'Ich stimme zu',
      'terms-agree-error': 'Du musst den AGBs zustimmen',
      delivery:
        'Kostenlose Lieferung bei einer Vorbestellung/Bestellung von mindestens {price} €.',
      free_delivery_left:
        'Nur noch <strong class="text-color-secondary">{price} €</strong> bis zur kostenlosen Lieferung',
      delivery_free: 'Hoffentlich gefällt’s euch !',
      delivery_free_sub: 'Die Lieferung geht aufs Haus.',
      cgv: 'AGBs',
      upsell: {
        title: {
          default: 'Das könnte euch auch gefallen',
          empty: 'Werft einen Blick auf die Asphalte-Lieblinge.',
          link: 'Ergänzende Produkte',
          'Les éternels': 'Das könnte euch auch gefallen',
          Cluster: 'Ähnliche Teile',
        },
        default: 'Auch zum vorbestellen',
        link: 'Für euren Anzug',
        eternel: 'Unsere Essentials',
        'Les éternels': 'Lieferung zur gleichen Zeit',
        info: 'Jetzt vorbestellen | Erhältlich in {number} Farben',
        action: 'ZEIGT MAL',
        h: {
          default: 'Für ihn',
          'Les éternels': 'Für ihn / Unsere Essentials',
        },
        f: {
          default: 'Für sie',
          'Les éternels': 'Für sie / Unsere Essentials',
        },
      },
      payments: 'Zahlungsmethoden',
    },
    cookie: {
      text: 'Unsere Newsletter sprechen jetzt auch die Sprache des Landes der Dichter und Denker.',
      link: 'Faust drauf.',
    },
    label: {
      color: 'Farbe:',
      size: 'Größe:',
      jacket: 'Jackengröße:',
      pant: 'Hosengröße:',
      amount: 'Menge:',
      quantity: 'Menge:',
    },
    locale: {
      'de-DE': 'Deutsch',
      'en-US': 'English',
      'fr-FR': 'Français',
      small: {
        'de-DE': 'DE',
        'en-US': 'EN',
        'fr-FR': 'FR',
      },
    },
    countdown: {
      days: 'tag | tage',
      hours: 'stunde | stunden',
      minutes: 'minute | minuten',
      seconds: 'sekunde | sekunden',
      abbr: {
        days: 'T-{days}',
        hours: 'S-{hours}',
      },
    },
    faq: {
      title: 'FAQ',
      line1: {
        title: 'Wie kann ich mein Asphalte-Guthaben ausgeben?',
        content:
          'Kopiere einfach deinen Promo-Code und gebe ihn beim Check-out an, wenn du bestellst. Du kannst ihn sowohl für Vorbestellungen, als auch Lagerbestellungen einlösen, nur nicht für Versandkosten.',
      },
      line2: {
        title: 'Was kann ich mit dem Guthaben kaufen?',
        content:
          'Der Promo-Code gilt sowohl für Vorbestellungen, als auch Lagerbestellungen.',
      },
      line3: {
        title:
          'Was passiert, wenn mein Guthaben größer ist, als die Bestellsumme?',
        content:
          'Keine Sorge, wir gleichen die Balance einfach an. Falls du also 100 € Guthaben hast und nur für 79 € bestellst, befinden sich immer noch 21 € in deinem Guthaben-Konto.',
      },
      line4: {
        title: 'Kann derselbe Promo-Code mehrmals genutzt werden?',
        content:
          'Ja, denn du hast nur einen Code, der immer wieder genutzt werden kann, um dein Guthaben einzulösen.',
      },
      line5: {
        title: 'Kann eine andere Person mein Guthaben einlösen?',
        content:
          'Leider nein, denn der Code ist mit deinem Konto verbunden, sodass er nur von dir benutzt werden kann. Falls du dein Guthaben jemandem zur Verfügung stellen willst, dann müsst ihr über dein Konto bestellen.',
      },
    },
    header: {
      menu: {
        eshop: 'E-shop',
      },
    },
    footer: {
      cgv: 'AGBs',
      cookie: 'Cookies',
      newsletter: {
        man: 'Herrenkollektion',
        woman: 'Damenkollektion',
        subscribe: 'Alles Klar',
        error: 'Oh nein... Es ist etwas Schlimmes passiert.',
      },
      payments: {
        info: 'Eine Angabe über alle Zahlungsmöglichkeiten, die euch für den Kauf zur Verfügung stehen. Diese Auswahl kann je nach Lieferadresse variieren.',
      },
    },
    create_alert: {
      email: { placeholder: 'Gib hier deine E-Mail Adresse ein' },
      subscribe: 'Sagt mir Bescheid',
    },
    product: {
      in_preco: 'Als vorbestellung',
      in_stock: 'Aus dem lager',
      'available-from': 'Verfügbar ab {weekday}, den {month-day}',
      'receive-alert-preorder':
        'Bekomme eine Mitteilung, sobald das Produkt vorbestellt werden kann.',
      'receive-alert-stock':
        'Richte dir eine Mitteilung ein, um zu wissen, wann das Produkt wieder verfügbar ist:',
      'color-not-available': 'So ein Seemannsgarn',
      'size-not-available': 'Der Artikel ist ausverkauft.',
      'soldout-saisonnier': `Sorry, aber das Garn für diese Farbe scheint uns ausgegangen zu sein. Sei der Erste, der erfährt, wenn dieser Artikel wieder vorbestellt werden kann.`,
      'back-one-day': 'Kommt irgendwann zurück',
      price_range: 'Von {min} € bis {max} €',
      available_sizes: 'Verfügbare Größe:',
      tag: {
        soon_preco: 'Zeit bis zur Vorbestellung:',
        last_before_end: 'Die Vorbestellungen enden in',
        last_chance: 'Letzte Chance',
        new_color: 'Neue Farbe',
        leaving_soon: 'Bald verfügbar',
      },
      soldout:
        'Sorry, aber das Garn für diese Farbe scheint uns ausgegangen zu sein. Sei der Erste, der erfährt, wenn dieser Artikel wieder vorbestellt werden kann.',
      soldout_stock:
        'Der Bestand für diese Farbe ist ausverkauft. Bitte melden Sie sich unten an, und Sie werden als Erster informiert, wenn diese Farbe wieder auf Lager ist.',
      almost_sold_out:
        '<strong>Letzter verfügbarer Artikel</strong> | Nur noch <strong>{number} Artikel verfügbar</strong>',
      sold: 'Schon <strong>{sold}</strong> Vorbestellung | Schon <strong>{sold}</strong> Vorbestellungen',
      alert: {
        activated:
          'Du bekommst eine Nachricht an diese E-Mail-Adresse, sobald wir sagen: {produit} - Endlich wieder da! <strong>{email}</strong>.',
        deactivated: 'Mitteilungen für {produit} abgemeldet',
        'unsubscribe-loading': 'Abmeldung wird ausgeführt',
        love: '{produit} ist/sind nun auf Ihrer Jagdliste. Verlassen Sie sich darauf, dass wir Ihnen eine E-Mail schicken, sobald er/sie/es verfügbar ist.',
        unlove:
          '{produit} wurde/wurde/n von deinen Favoriten entfernt. Ihr habt euch geliebt, lasst uns nicht mehr darüber reden und das Leben geht weiter.',
        error:
          'Es gab ein Problem bei der Anmeldung. Wendet euch bitte an den Kundenservice, falls dieses weiterhin besteht.',
        highlight_title: '{name}: {date}',
        modal: {
          title: 'Mitteilung gespeichert!',
          NOT_FOUND: {
            subtitle: 'Konto erstellen, um Mitteilungen zu verwalten.',
            explanations:
              'Sieht so aus, als ob du noch kein Konto eingerichtet hättest. Wenn du das tust, musst du nicht ständig deine E-Mail Adresse eingeben, um Mitteilungen einzurichten. Außerdem kannst du sie alle an einem Ort verwalten.',
            where: 'Ein paar Minuten können dir viel Zeit sparen.',
            action: 'Einrichten',
          },
          ENABLED: {
            subtitle: 'Einloggen, um Mitteilungen zu verwalten.',
            explanations:
              'Du wirst zuerst benachrichtigt, wenn der Artikel vorbestellbar oder wieder auf Lager ist!',
            where:
              'Falls du deine Meinung änderst - kein Problem. Du kannst alle Mitteilungen ganz einfach in deinem Konto verwalten.',
            action: 'Einloggen',
          },
          DISABLED: {
            subtitle: 'Konto aktivieren, um Mitteilungen zu verwalten.',
            explanations:
              'Sieht so aus, als ob du noch kein Konto eingerichtet hättest. Wenn du das tust, musst du nicht ständig deine E-Mail Adresse eingeben, um Mitteilungen einzurichten. Außerdem kannst du sie alle an einem Ort verwalten.',
            where: 'Ein paar Minuten können dir viel Zeit sparen.',
            action: 'Konto aktivieren',
          },
          unsubscribe: {
            title: 'Mitteilung gelöscht!',
            NOT_FOUND: {
              explanations:
                'Sieht so aus, als ob du noch kein Konto eingerichtet hättest. Wenn du das tust, musst du nicht ständig deine E-Mail Adresse eingeben, um Mitteilungen einzurichten. Außerdem kannst du sie alle an einem Ort verwalten.',
              where: 'Ein paar Minuten können dir viel Zeit sparen.',
            },
            ENABLED: {
              explanations: 'Fertig. Du bekommst keine Mitteilungen mehr.',
              where:
                'Falls du deine Meinung änderst - kein Problem. Gehe zu unser Kommt Bald Seite und ändere deine Mitteilungen.',
            },
            DISABLED: {
              explanations:
                'Sieht so aus, als ob du noch kein Konto eingerichtet hättest. Wenn du das tust, musst du nicht ständig deine E-Mail Adresse eingeben, um Mitteilungen einzurichten. Außerdem kannst du sie alle an einem Ort verwalten.',
              where: 'Ein paar Minuten können dir viel Zeit sparen.',
            },
          },
        },
      },
      nav: {
        product: 'Produkt',
        videoBlock: 'Video',
        issueBlock: 'Was wir vermieden haben',
        user_generated_content: 'Lasst euch inspirieren',
        simpleContentBlock: 'Beschreibung',
        morphoBlock: 'Größen',
        tracabiliteBlock: 'Rückverfolgbarkeit',
        impactBlock: 'Umweltauswirkungen',
        avisClientBlock: 'Kundenrezensionen',
        assuranceBlock: 'Unsere Garantien',
        other: 'Weiter',
        action: {
          precommande: 'Vorbestellen',
          stock: 'Kaufen',
          agenda: 'Mitteilung einrichten',
        },
      },
      material: {
        title: 'Material:',
        label: '{label}:',
        popup:
          '<p class="d-flex align-center text-base-mobile mb-0-6">{icon} <strong class="ml-0-4">{label} {name}</strong></p>',
      },
      filters: {
        type: {
          Accessoires: 'Accessoires',
          Chaussures: 'Schuhe',
          Chemises: 'Hemden',
          Costumes: 'Anzüge',
          'Manteaux et Vestes': 'Mäntel und Jacken',
          'Pantalons et Shorts': 'Hosen und Shorts',
          'Pulls et Sweats': 'Pullover und Sweatshirts',
          'Sous-vêtements et Maillots de bain':
            'Unterwäsche und Badebekleidung',
          'T-shirts et Polos': 'T-Shirts und Polos',
        },
      },
      color: {
        leaving_soon: {
          title: 'Bald verfügbar.',
          desc: '{left} um {product} in {colour} vorzubestellen. Nach dieser Frist wird diese Farbe nicht mehr vorbestellbar sein.',
          days_left: 'Letzter Tag | Nur noch 1 Tag | Noch {count} Tage',
          some_days: 'Nur noch wenige Tage übrig',
          ended: 'Die Vorbestellung für die Farbe ist beendet.',
        },
        new: {
          title: 'Neue Farbe',
          desc: 'Gerade veröffentlicht.',
        },
      },
    },
    purchase: {
      price: {
        preco: 'Als Vorbestellung',
        stock: 'Auf Lager',
      },
      timer: {
        before: 'Bestelle innerhalb der nächsten',
        over: 'Vorbestellungen sind vorbei',
        only: 'Nur',
        left: 'verfügbar',
      },
      estimatedDelivery: 'Voraussichtliche Lieferung:',

      delivery: 'Lieferung:',
      batchEnd:
        'um deine Lieferung Zwischen<br />dem {first}. und dem {last}. {month}',
      precoEnd: 'bis zum Ende der Vorbestellungphase',
      stockEnd: 'bis zum Ende des Verkaufs',
      precoEndTooltip:
        'Wer zuerst kommt, mahlt zuerst. Ihr kennt das Spiel. Wenn ihr jetzt vorbestellt, erhaltet ihr euren Artikel zwischen dem {current_first} und dem {current_last} {current_month}. Wenn ihr es bis nächste Woche aufschiebt, kommt der Artikel zwischen dem {next_first} und dem {next_last} {next_month} bei euch an.',
      nextPrecoDelivery: 'um deine Lieferung in',
      already: '',
      preco: 'teile vorbestellt',
      nbPreco: 'Teile vorbestellt',
      inStock: 'Teile auf Lager',
      'size-guide': 'Größentabelle',
      exchange: 'Lieferung & Rücksendung',
      fewDays: 'Wird in wenigen Tagen geliefert',
      noDays: 'Datum derzeit nicht angegeben',
      contactCare:
        'Für weitere Informationen wenden Sie sich bitte an unseren Kundenservice.',
      beforeChristmas: 'Vor Weihnachten',
      stock_preco_why: 'Wie funktioniert es?',
      between: 'Zwischen dem {first}. und dem {last}. {month}',
      fromTo: '{first} bis {last} {month} zu erhalten',
      label: {
        jacket: 'Jacke:',
        pant: 'Hose:',
      },
      no: {
        jacket: 'Keine Jacke',
        pant: 'Keine Hose',
      },
      errors: {
        size: {
          empty: 'Bitte eine Größe auswählen.',
        },
        addToCart: {
          fail: 'Oh oh... da hat sich ein technischer Fehler eingeschlichen. Versuch es später nochmal <a href="https://help.asphalte.com/article/yni5jp9af8-contact" target="_blank">oder melde dich beim Kundenservice</a>, wenn es dringend ist.',
        },
      },
    },
    orders: {
      error: {
        loading:
          ' Houston, wir haben ein Problem. Die Mission „Bestellungen laden“ hat nicht wie erhofft funktioniert. Bitte versucht, die Seite zu aktualisieren. Wenn das Problem weiterhin besteht, sagt unserem Kundenservice Bescheid.',
      },
      title: 'Meine Bestellung',
      almost_there: 'Gleich bei dir!',
      filters: {
        label: 'Meine letzte Bestellungen:',
        in_progress: 'In Bearbeitung',
        returns: 'Ausgetauscht',
        year: '{year}',
      },
      no_order: 'No orders made as yet',
    },
    order: {
      number: 'Bestellung n°',
      number_param: 'Bestellung n°{number}',
      number_full: 'Bestellnummer :',
      created_at: 'Made on',
      channel: {
        label: 'Verkaufskanal:',
        online: 'Online',
        retail: 'Im Laden',
      },
      delivery_at: 'Delivery to',
      go_to: 'Bestelldetails anzeigen',
      detail: 'Bestelldetails',
      print: 'Rechnung drucken',
      shipping: 'Art der Lieferung',
      shipping_address: 'Lieferadresse',
      billing_address: 'Rechnungsadresse',
      update_address: {
        title: 'Lieferadresse aktualisieren',
        edit: 'Meine Adresse aktualisieren',
        label: 'Informationen:',
        info: 'Wir werden Sie einige Tage vor der Lieferung per E-Mail kontaktieren, falls Sie die Adresse kurzfristig ändern müssen.',
        pickup_point_update:
          'Möchten Sie Ihre Bestellung lieber an einem Abholpunkt abholen?',
        change_to_pickup_point: 'Ich wähle die Lieferung an einen Abholpunkt',
        update_pickup_point: 'Abholpunkt aktualisieren',
        choice: 'Wahl der Liefermethode',
        choose_home_delivery: 'Ich möchte eine Lieferung nach Hause',
        lock_country_reason:
          'Sie können das Lieferland, das der ursprünglichen Bestellung zugeordnet ist, nicht ändern. Wenn dies ein spezifischer Wunsch ist, wenden Sie sich bitte an unseren Kundenservice.',
        delivery: {
          domicile: 'Lieferung nach Hause',
          relais: 'Lieferung an Abholpunkt',
          new_address: 'Neue Adresse hinzufügen',
          save_for_later: 'Diese Adresse zu meiner Adressliste hinzufügen',
          hide_all_addresses: 'Alle gespeicherten Adressen ausblenden',
          show_all_addresses: 'Alle gespeicherten Adressen anzeigen',
          save: 'Lieferadresse aktualisieren',
          error_no_address: 'Bitte wählen Sie eine Lieferadresse aus',
        },
        pickup_point: {
          search_label:
            'In welchem Gebiet möchten Sie nach einem Abholpunkt suchen?',
          search: 'Abholpunkte in der Nähe dieser Adresse anzeigen',
        },
        error: {
          default:
            'Beim Aktualisieren der Lieferadresse ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, zögern Sie nicht, unseren Kundenservice zu kontaktieren.',
          cannot_change_shipping_country:
            'Sie können das mit der ursprünglichen Bestellung verknüpfte Lieferland nicht ändern. Wenn es sich um eine besondere Anfrage handelt, kontaktieren Sie bitte unseren Kundenservice.',
        },
      },
      home_delivery: 'Mit Sendungsverfolgung bis an deine Tür',
      relay_point_delivery: 'Pickup point delivery',
      see_map: 'Siehe auf der Karte',
      email: 'E-Mail-Adresse',
      paymentMode: 'Zahlungsmethode',
      phone: 'Telefon',
      follow: 'Meine Sendung verfolgen',
      delivered_by: 'Track my {trackingCompany} delivery',
      fullfilment_number: 'Sendungsnummer :',
      inside_box: 'Was ist in der Box',
      canceledAt: 'Diese Bestellung wurde storniert am {date}',
      refunded: 'Betrag erstattet',
      cancel_reason: {
        CUSTOMER: 'Bestellung auf Kundenwunsch storniert',
        DECLINED: 'Bestellung storniert aufgrund einer abgelehnten Zahlung',
        FRAUD: 'Bestellung storniert wegen möglichem Betrug',
        INVENTORY: 'Bestellung storniert wegen mangelnder Lagerbestände',
      },
      delivery: 'Erwartete Lieferung',
      initial_delivery: 'Ursprünglicher Liefertermin: ',
      new_delivery: 'Neuer Liefertermin: ',
      careGuide: 'Pflegeanleitung',
      retoucheurs: 'Änderungen vornehmen',
      line: {
        'in-some-days': 'Lieferung erwartet: in einigen Tage',
        deleted: 'Der Artikel wurde aus der Bestellung entfernt',
      },
      returns: {
        title: 'Rückgaben',
        'how-to': 'Alles, was Sie über Rückgaben wissen müssen',
        explains:
          'Wenn ein Artikel nicht Deine Vorstellungen entspricht oder nicht die richtige Größe hat, kannst du ihn zurückgeben, indem du auf die Schaltfläche unten klickst',
      },
      recap: 'Zusammenfassung der Bestellung',
      subtotal: 'Zwischensumme',
      discount: {
        items: 'Rabatt auf Artikel',
        shipping: 'Rabatt auf Lieferkosten',
      },
      'shipping-price': 'Lieferkosten',
      total: 'Insgesamt bezahlt',
      exchange: 'Umgetauscht nach Rückgabe,',
      inside: 'In meiner Bestellung',
      items: '{number} Artikel | {number} Artikel',
      shippingStatus: {
        DELIVERED: 'Geliefert',
        PACKED: 'Versandfertig',
        SHIPPED: 'Versandt',
        PREPARATION: 'In Vorbereitung',
        SCHEDULED: 'Bald in Vorbereitung',
        RAW: 'In Bearbeitung',
      },
      status: {
        label: 'Status',
        label_pt: 'Status :',
        RAW: 'Ausstehend',
        CANCELED: 'Abgebrochen',
        CANCELLED: 'Abgebrochen',
        AUTHORIZED: 'Autorisiert',
        PAID: 'Bezahlt',
        PARTIALLY_PAID: 'Teilweise bezahlt',
        PARTIALLY_REFUNDED: 'Teilweise zurückerstattet',
        PARTLY_DELIVERED: 'Teilweise geliefert',
        PENDING: 'Zahlung ausstehend',
        REFUNDED: 'Zurückerstattet',
        DELIVERED: 'Geliefert',
        EXCHANGE: 'Umtausch',
        IN_TRANSIT: 'Zur Auslieferung bereit',
        VOIDED: 'Gelöscht',
      },
      line_item: {
        CANCELED: 'Abgebrochen',
      },
      timeline: {
        created: 'Bestellung erhalten',
        packed: "Paket verschickt, los geht's",
        in_transit: 'Paket auf dem Weg, jede Minute jetzt',
        delivered: 'Endlich bei dir',
      },
      pickup_point: {
        opening_hours: 'Öffnungszeiten',
        opening_days: 'Geöffnet am <strong>{days}</strong>',
        all_days: 'Geöffnet <strong>jeden Tag</strong>',
        closed: 'Geschlossen',
        open: {
          during_lunch: 'Während der Mittagspause',
          after_7: 'Nach 19 Uhr',
        },
        days: {
          0: 'Montag',
          1: 'Dienstag',
          2: 'Mittwoch',
          3: 'Donnerstag',
          4: 'Freitag',
          5: 'Samstag',
          6: 'Sonntag',
        },
        show_hours: 'Öffnungszeiten anzeigen',
        hide_hours: 'Öffnungszeiten ausblenden',
      },
      scheduled: {
        title: 'Deine Bestellung ist auf der Zielgeraden',
        subtitle:
          'Du kannst deine Lieferadresse noch bis heute um Mitternacht ändern',
      },
      reschedule: {
        title:
          'Wenn du den Liefertermin verschieben möchtest, ist jetzt der richtige Zeitpunkt gekommen',
        form_label:
          'Wähle das neue Datum, ab dem du deine Bestellung erhalten möchtest',
        cta: 'Meine Lieferung verschieben',
        cta_label: 'Neues gewünschtes Lieferdatum',
        submit: 'Bearbeiten',
        success: 'Erfolgreich umdisponierte Lieferung',
        error: 'Fehler bei der Neuprogrammierung der Lieferung',
      },
      error: {
        shipping_loading:
          'Beim Laden Ihrer Lieferadresse ist ein Fehler aufgetreten. Wenn das Problem nach dem erneuten Hochladen Ihrer Seite weiterhin besteht, wenden Sie sich bitte an unseren Kundenservice.',
      },
    },
    sponsorship: {
      title: 'Weiterempfehlungsprogramm',
      intro: `
        <p>
          Auch wenn dir das Prinzip sicher klar ist, fassen wir es nochmal kurz zusammen: Hier findest du deinen individuellen Code, 
          den du mit deinen Freunden, Kollegen, Schwiegereltern und flüchtigen Bekannten teilen kannst. 
          Jedes Mal, wenn einer deiner Leute zum ersten Mal bei Asphalte bestellt und dabei deinen Code beim Checkout eingibt, 
          bekommst du {parrainageprice} € gutgeschrieben und dein Freund erhält {parrainagefilleulprice} € Rabatt auf seine Erstbestellung. Eine klassische Win-Win Situation.
        </p>
        <p>Und bevor du fragst, hier ist dein magischer Code, mit dem du dich und deine Freunde glücklich machen kannst:</p>
        `,
      code: 'Mein Weiterempfehlungscode:',
      messageToShare:
        'Nicht so der Briefeschreiber?<br />Dann helfen wir dir, deinen Freunden zu erklären, wie es geht:',
      message: `
        Schonmal von Asphalte gehört? Es ist ein französisches Modelabel, das rückverfolgbare, hochwertige Kleidung herstellt, die fair in Europa produziert wird. Sie verwenden ein Vorbestellungsmodell, wodurch Abfall reduziert und auf eine bessere Art der Kleidungsherstellung hingearbeitet wird. Klingt gut, oder? Willst du {parrainageprice} € Rabatt auf deine erste Bestellung erhalten? Natürlich willst du das: Dafür musst du nur diesen Empfehlungscode beim Checkout eingeben: {code}.
        Schau mal auf der Website vorbei, um zu sehen, ob du was findest: <a href="{link}"><u>{link}</u></a>
        `,

      cagnotte: {
        title: 'Guthaben',
        explain: `<p>Und was dein Guthaben angeht… das kannst du ausgeben, wann immer du möchtest. Dafür musst du nur deinen Guthabencode beim Checkout eingeben.</p>`,
        'you-have': 'Aktuelles Guthaben :',
        code: 'Mein Guthabencode:',
      },

      cheat: {
        title: 'Kleine Info an alle Schlingel unter euch:',
        text: 'Das Weiterempfehlungsprogramm funktioniert nur, wenn alle an einem Strang ziehen und wir uns an die Regeln halten. Also unterschiedliche Konten einrichten, um euch selbst Codes zu schicken und andere Späßchen könnt ihr direkt bleiben lassen, das finden wir heraus und dann müssen wir euch für das Weiterempfehlungsprogramm sperren (schaut mal in unsere AGBs). Nutzt die Zeit lieber und schickt den Empfehlungscode an interessierte Personen und unterstützt dabei ein Unternehmen, das ihr eigentlich mögt. Klingt besser, oder?',
      },
      faq: {
        line1: {
          title: 'Wer kann weiterempfehlen?',
          content:
            'Nur Kund*innen, die schon einmal bei Asphalte bestellt und ein Konto erstellt haben.',
        },
        line2: {
          title: 'An wen kann der Code gesendet werden?',
          content:
            'An alle Personen, die noch nie bei Asphalte bestellt haben.',
        },
        line3: {
          title: 'Sind alle Versandkosten umsonst?',
          content:
            'Die Versandkosten sind kostenlos für alle Personen, die über den Weiterempfehlungscode zum ersten Mal bei Asphalte bestellen und solange die Versandkosten nicht mehr als 15 € betragen.',
        },
        line4: {
          title: 'Wie kann ich jemanden weiterempfehlen?',
          content:
            'Ganz einfach den persönlichen Weiterempfehlungscode teilen. Dieser kann dann beim Check-out angegeben werden. Beachten Sie bitte, dass ein Mindesteinkaufswert von 50 Euro erforderlich ist, damit der Code gültig ist.',
        },
        line5: {
          title: 'Kann ich mehrere Personen weiterempfehlen?',
          content:
            'Natürlich. Falls die Frage also lautet: Können meine Freunde für meine Asphalte-Klamotten zahlen? Dann lautet die Antwort: absolut.',
        },
        line6: {
          title: 'Gibt es ein Limit?',
          content: 'Ja, das Limit liegt bei 25 Personen.',
        },
        line7: {
          title: 'QuaWann sehe ich mein Guthaben in meinem Konto?',
          content:
            'Sobald die Bestellung über den persönlichen Code bestätigt wurde, schicken wir dir eine E-Mail, in der steht, dass dir {parrainageprice} € Guthaben gut geschrieben wurden, das sofort eingelöst werden kann.',
        },
      },
      requirements:
        'Sie müssen eine Bestellung aufgeben, um Ihren Code zu aktivieren',
    },
    people: {
      verified: 'Verifizierter Kauf',
    },
    testimonial: {
      action: {
        show: 'Schaut euch Reviews an',
        hide: 'Verstecken euch Reviews an',
      },
      see: 'Schaut euch {number} Reviews an',
      based_on_number: 'Basierend auf {number} Bewertungen',
      size: 'Größe:',
      color: 'Farbe:',
      number: '{number} Review | {number} Reviews',
      'based-on': 'Basierend auf {number} Reviews',
      'no-comment': 'Kein Kommentar',
      empty: 'Keine Reviews unter diesem Stichwort gefunden',
      loading: 'Reviews werden geladen',
      filter: {
        by: 'Filtern nach:',
        color: 'Farbe',
        size: 'Größe',
        note: 'Notiz',
      },
    },
    impact: {
      unit: {
        Carbone: 'kg',
        Eau: 'l',
        Energie: 'mj',
        Phosphate: 'g',
      },
      conso: {
        Carbone: 'CO2 Emissionen',
        Eau: 'Wasserverbrauch',
        Energie: 'Stromverbrauch',
        Phosphate: 'Phosphor Emissionen',
      },
      detail: {
        Carbone: 'Quelle: Europäische Umweltagentur, November 2020.',
        Eau: 'Messungen basieren auf dem nationalen Durchschnitt, Véolia',
        Energie: 'Quelle: Engie, Januar 2020',
        Phosphate: 'Quelle: AgriBalyse, https://agribalyse.ademe.fr/',
      },
    },
    input: {
      empty: 'Eingabe erforderlich',
      optional: 'Optional',
      gender: {
        homme: 'Herr',
        femme: 'Frau',
        undefined: 'Nicht binär',
      },
      email: {
        label: 'E-Mail',
        placeholder: 'Adresse hier rein',
        wrong: 'Du musst deine E-Mail angeben',
      },
      date: {
        minDate: 'Das Datum ist kleiner als das Mindestdatum',
        maxDate: 'Das Datum ist größer als das maximale Datum',
      },
      error: {
        UNIDENTIFIED_CUSTOMER: 'Falsches Passwort',
        BAD_DOMAIN: '',
        BLANK: '',
        CONTAINS_HTML_TAGS: '',
        CONTAINS_URL: '',
        CUSTOMER_DISABLED: '',
        INVALID: '',
        INVALID_MULTIPASS_REQUEST: '',
        NOT_FOUND: '',
        PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE: '',
        TAKEN: '',
        TOKEN_INVALID: '',
        TOO_LONG: '',
        TOO_SHORT: '',
        ALREADY_ENABLED: 'Dein Konto wurde schon aktiviert',
        PHONE: 'Ungültige Telefonnummer',
        passwordLength: 'Dein Passwort muss aus mind. 6 Buchstaben bestehen',
        password_match: 'Die Passwörter stimmen nicht überein.',
        invalid_password: 'Das Passwort ist falsch.',
        sexe: 'Bitte auswählen',
        firstName: 'Ungültiger Vorname',
        lastName: 'Ungültiger Nachname',
      },
    },
    account: {
      hello: 'Hallo',
      welcome:
        'Willkommen auf deinem <span class="text-color-secondary">Asphalte-Konto</span>',
      enjoy: {
        default:
          'Rosen sind rot, Veilchen sind blau, wir bei Asphalte erleichtern euch nachhaltiges Shopping... Wow!',
        birthday:
          'Happy Birthday {name}, 🎤 Glaub uns, es ist besser, dass wir es schreiben, statt zu singen.',
        morning: 'Guten Morgen.',
        day: 'Unser Team in Bordeaux lässt ausrichten: Wir hoffen, dein Tag ist fein wie unser Wein.',
        evening: 'Hab einen schönen Abend.',
        new_year: 'Wir wünschen dir ein frohes neues Jahr.',
        first_order_birthday:
          'Alles Liebe zum Jahrestag deiner ersten Asphalte-Bestellung.',
      },
      label: 'Mein Konto',
      labels: {
        email: 'Email',
        password: 'Passwort',
        birthday: 'Geburtsdatum',
        gender: 'Geschlecht',
        firstname: 'Vorname',
        lastname: 'Nachname',
        phone: 'Telefon',
        current_password: 'Aktuelles Passwort',
        new_password: 'Neues Passwort',
        new_password_confirmation: 'Bestätigung des neuen Passworts',
      },
      nav: {
        home: 'Mein konto',
        orders: 'Mein Bestellverlauf',
        profile: 'Mein Konto',
        address: 'Meine Adressen',
        parrainage: 'Mein Guthaben',
        alerts: 'Meine Mitteilungen',
        logout: 'Ausloggen',
      },
      menu: {
        orders: {
          preTitle: 'Mein',
          title: 'Bestellverlauf',
          description:
            'Hier findest du eine Übersicht über all deine Bestellungen, inklusive aktueller Vorbestellungen und Rechnungen.',
        },
        profile: {
          preTitle: 'Mein',
          title: 'Konto',
          description:
            'Hier kannst du dein Leben verwalten. Oder zumindest deine E-Mail-Adresse, dein Passwort, deinen Namen und deine Telefonnummer.',
        },
        address: {
          preTitle: 'Meine',
          title: 'Adressen',
          description:
            'Deine Adressen und Lieferpräferenzen kannst du hier anpassen, damit es deine Lieblingsteile entspannt zu dir schaffen.',
        },
        alerts: {
          preTitle: 'Meine',
          title: 'Mitteilungen',
          description:
            'Du willst täglich von uns hören? Wir fühlen uns geschmeichelt. Du möchtest ein wenig Abstand? Auch das verstehen wir. Hier kannst du deine Asphalte-Mitteilungen verwalten und deinen bevorzugten Newsfeeds auswählen.',
        },
        parrainage: {
          preTitle: 'Mein',
          title: 'Guthaben',
          description: 'Weiterempfehlungsprogramm und Guthaben.',
        },
        care_guides: {
          preTitle: 'Die',
          title: 'Pflegeanleitungen',
          description:
            'Alle unsere Tipps zur Pflege Ihrer Kleidung und Schuhe.',
        },
      },
      address: {
        default: 'Meine Standardadresse',
        is_default: 'Standardadresse',
        list: 'Meine Adresse',
        create: 'Neue Adresse',
        edit: 'Adresse bearbeiten',
        firstName: 'Vorname',
        lastName: 'Nachname',
        companyName: 'Unternehmen',
        address1: 'Adresse',
        address2: 'Adresszusatz',
        city: 'Stadt',
        postalCode: 'Postcode',
        country: 'Land',
        province: 'Provinz',
        state: 'Staat',
        select_province: 'Wähle eine Provinz',
        select_state: 'Wähle einen Staat',
        phone: 'Telefonnummer',
        phone_explain:
          'Damit unser Partner dich im Falle eines Problems mit der Lieferung kontaktieren kann',
        error:
          'Une erreur est survenue, si le problème persiste, veuillez contacter le service client.',
        error_taken: 'Cette adresse est déjà enregistrée',
        no_address: 'Aucune adresse enregistrée pour le moment.',
      },
      profile: {
        informations: 'Meine Informationen',
        password: 'Mein Passwort',
        no_mail:
          'Sie können Ihre E-Mail-Adresse derzeit nicht ändern, da die Funktion auf unserer Seite noch nicht aktiv ist. Wenn Sie Ihre E-Mail-Adresse aktualisieren müssen, zögern Sie nicht, den Kundenservice zu kontaktieren.',
      },
      title: 'Einloggen',
      p1: 'Um dich in deinem Konto anmelden, oder dich zu registrieren, gibt hier deine E-Mail ein.',
      placeholder: {
        email: 'Beispiel@email.com',
      },
      error: {
        email: 'Ungültige E-Mail Adresse',
      },
      nextButton: 'Einloggen',
      activationLinkSent:
        'Wir haben dir vor Kurzem eine E-Mail geschickt, um dich darüber zu informieren, dass wir unsere Website technisch überholt haben. Aus Sicherheitsgründen müssen wir dich nun darum bitten auf „Konto reaktivieren” zu klicken, um all unsere neuen Features nutzen zu können.',
      /* 'Eine E-Mail wurde dir zugeschickt. Klicke auf ‚Konto aktivieren‘, um deine Registrierung abzuschließen.', */
      wait: 'Wenn Du innerhalb zehn Minutes keine E-Mail von uns erhalten hast, kannst Du es erneut versuchen.',
    },
    password: {
      security: {
        advice:
          'Wir empfehlen Ihnen, ein sicheres Passwort zu wählen, das folgende Kriterien erfüllt :',
        length: 'Enthält mindestens 8 Zeichen',
        uppercase: 'Enthält mindestens einen Großbuchstaben',
        lowercase: 'Enthält mindestens einen Kleinbuchstaben',
        number: 'Enthält mindestens eine Zahl',
        special: 'Enthält mindestens ein Sonderzeichen',
        label: 'Sicherheit :',
        weak: 'Schwach',
        medium: 'Mittel',
        strong: 'Stark',
      },
    },
    register: {
      title: 'Registrieren',
      p: 'Uns wurde zugeflüstert, dass du kein Asphalte-Konto hast. Keine Sorge, das ändern wir. Beantworte einfach ein paar kurzen Fragen: ',
      placeholder: {
        firstName: 'Alex',
        lastName: 'Alexander',
      },
      error: {
        unexpectedError:
          'Irgendwas stimmt hier nicht. Setze dich mit unserem Kundenservice in Verbindung.',
      },
      password: 'Passwort',
      changeEmail: 'E-Mail ändern',
      nextButton: 'Weiter',
      sendButton: 'Registrieren',
      sexe: 'Geschlecht',
      men: 'Männlich',
      women: 'Weiblich',
      firstName: 'Vorname',
      lastName: 'Nachname',
      date: 'Geburtsdatum',
      news: 'Anmeldung',
      newsText:
        'Ich will auf jeden Fall auf dem Laufenden bleiben (Umfragen, Vorbestellungen), aber übertreibt es nicht.',
    },
    activate: {
      title: 'Aktiviere dein Konto',
      p: 'Du hast in der Vergangenheit bestellt, aber dein Konto nicht aktiviert. Wir haben nur ein paar kurze Fragen an dich, dann ändern wir das.',
      sendButton: 'Konto aktivieren',
    },
    login: {
      title: 'Einloggen',
      p: 'Hey, schön dich zu sehen, gut siehst du aus. Gib eben dein Passwort ein, wir sehen uns dann drinnen.',
      placeholder: {
        password: 'mindestens 6 Zeichen',
      },
      password: 'Passwort',
      forgotPasswordLink: 'Passwort vergessen ?',
      codeSent: 'E-Mail verschickt',
      forgotPasswordLinkSent:
        'Wir haben dir eine E-Mail geschickt, mit der du dein Passwort zurücksetzen kannst.',
      sendButton: 'Einloggen',
      rememberMe: 'Vergesst micht nicht',
    },
    reset_password: {
      title: 'Mein Passwort zurücksetzen',
      desc: 'Keine Sorge! Geben Sie ein neues Passwort für Ihr Konto ein',
    },
    request: {
      failed: 'Anfrage fehlgeschlagen',
      'no-result': 'Keine Treffer',
    },
    blog: {
      news: {
        noPost: 'Momentan keine Artikel.',
      },
      'guides-dentretien': {
        noPost: 'Momentan keine Pflegeanleitung verfügbar.',
      },
    },
    error: {
      happened:
        'Houston, wir haben ein Problem. Die Mission ist aus unbekannten Gründen fehlgeschlagen. Wenn das Problem nach Aktualisierung der Seite weiterhin besteht, zögern Sie nicht, unseren Kundenservice zu kontaktieren. Verstanden?',
      default: {
        title: 'Ups, da ist uns ein Fehler unterlaufen.',
        text: 'Diese Seite ist nicht verfügbar.',
        backToHome: 'Zurück zur Startseite',
      },
      reset_password: {
        INVALID:
          'Houston, wir haben ein Problem. Der Link ist nicht mehr gültig... Bitte starten Sie das Verfahren von Anfang an. Wenn das Problem nach mehreren Versuchen weiterhin besteht, zögern Sie nicht, unseren Kundenservice zu kontaktieren. Verstanden?',
        PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE:
          'Houston, wir haben ein Problem. Das Passwort darf nicht mit einem Leerzeichen beginnen oder enden.',
        TOO_LONG: 'Houston, wir haben ein Problem. Das Passwort ist zu lang.',
        TOO_SHORT: 'Houston, wir haben ein Problem. Das Passwort ist zu kurz.',
      },
      404: {
        title: '404 - Seite wurde nicht gefunden.',
      },
    },
    search: {
      type: {
        agenda: 'Kommy bald :',
        eshop: 'Eshop :',
        stock: 'Lagerverkauf :',
      },

      label: {
        article: 'Suchen Sie einen Artikel?',
        care_guide: 'Sie suchen einen Gesprächsleitfaden?',
      },

      no_result: 'Keine Ergebnisse',
      results: '{number} Ergebnis | {number} Ergebnis | {number} Ergebnisse',
      'number-of':
        '{number}  verfügbaren Produkte | {number }  Produkt verfügbar  | {number}  verfügbare Produkte',
      display: {
        cols: '1 Spalte | {number} Spalten',
        pageSize: {
          title: 'Nombre de produits par page',
        },
        listDisplay: {
          title: 'Affichage de la liste',
          list: 'Liste',
          grid: 'Grille',
        },
      },
      filter: {
        loading: 'loading',
        reset: 'Filter zurücksetzen',
        all_reset: 'Alle Filter zurücksetzen',
        selected: '{number} Elemente ausgewählt',
        title: 'Filter',
        wait_for_category:
          'Wählen Sie eine Kategorie, um nach Größe zu filtern',
        category: {
          title: 'Categorien',
          all: 'Alle',
        },
        size: {
          title: 'Größe',
          all: 'Alle',
        },
        price: {
          title: 'Preise',
          all: 'Alle',
        },
      },
      categories: {
        't-shirt': 'T-shirts',
        pulls: 'Pullover',
        'pants-shorts': 'Hosen & Shorts',
        chemises: 'Hemden',
        'manteaux-vestes': 'Mäntel & Jacken',
        chaussures: 'Schuhen',
        costumes: 'Anzüge',
        accessoires: 'Accessoires',
        maillots: 'Unterwäsche & Badeshorts',
      },
    },
    teasing: {
      title: 'IST DAS BILD FÜR EUCH AUCH UNSCHARF?',
      dates: '',
      subscribe:
        'Am besten ihr <strong>richtet euch eine Mitteilung ein</strong>, um alles zu sehen.',
      slice: {
        title: 'IST DAS BILD FÜR EUCH AUCH UNSCHARF?',
        dates: '',
        subscribe:
          'Am besten ihr <strong>richtet euch eine Mitteilung ein</strong>, um alles zu sehen.',
      },
      story: {
        title_1: 'IST DAS BILD FÜR EUCH AUCH UNSCHARF?',
        title_2: 'Netter Versuch. Immer noch unscharf...',
        title_3: 'Ja. Immer noch unverändert.',
        title_4: 'No. Non. Nein. Immer noch kein Glück.',
        title_5: 'Da hat aber jemand wirklich Interesse.',
        title_6: 'Immer noch hier?',
        title_7: 'Ganz schön hartnäckig.',
        title_8: 'OK. Wir geben auf.',
        title_inf: 'OK. Wir geben auf.',
      },
    },
    'co-creation': {
      title: 'Umfragen',
    },
    notification: {
      text: 'Sollen wir euch über unsere Neuerscheinungen auf dem Laufenden halten?',
      positive: 'Klar, sagt Bescheid.',
      negative: 'Nein, danke.',
    },
    questionnaire: {
      new: 'Neu !',
      available: 'Verfügbar',
      type: {
        'plan-de-collection': 'Umfrage zur Kollektion',
        development: 'Umfrage zur Entwicklung',
        'achat-matiere': 'Umfrage zu den Farben',
        satisfaction: 'Umfrage zur Zufriedenheit',
        brand: 'Umfrage zur Brand',
        'autres-sujets': 'Andere Umfragen',
      },
    },
    collection: {
      unlock: {
        error:
          'Guter Ansatz, aber versuch es noch einmal. Das Passwort stimmt nicht.',
        done: {
          title: 'Du bist dabei.',
          text: 'Sichere dir einen Early-Bird-Zugriff beim End-of-Summer Lagerverkauf von Asphalte. Bis 10 Uhr hast du Zeit, dann öffnen wir die digitalen Pforten auch für die Öffentlichkeit.',
        },
        input_password: {
          label:
            'Gib deinen Code ein, um Zugriff auf unseren Lagerverkauf zu erhalten.',
        },
        action: 'Loooos',
      },
    },
    banner: {
      app: {
        title: 'Laden Sie die Asphalte-App herunter.',
        text: 'Und gehen Sie mit uns zurück ins Jahr 2000.',
      },
    },
  })
}
